import gql from 'graphql-tag'

export const getExecutivesForReports = gql`
  query executivesForReports{
    records: executives_for_reports
  }
`
